import { render } from "./CalendarEventOfferSelectionOverlay.vue?vue&type=template&id=9bd78658"
import script from "./CalendarEventOfferSelectionOverlay.vue?vue&type=script&lang=ts"
export * from "./CalendarEventOfferSelectionOverlay.vue?vue&type=script&lang=ts"
script.render = render

export default script